import type { Song } from "../types";

/** Old MacDonald Had a Farm (traditional, public domain). */
export const oldMacdonald: Song = {
  id: "old-macdonald",
  title: "Old MacDonald",
  bpm: 110,
  instrument: "piano",
  notes: [
    { key: "C4", beats: 1 },
    { key: "C4", beats: 1 },
    { key: "C4", beats: 1 },
    { key: "G4", beats: 1 },
    { key: "A4", beats: 1 },
    { key: "A4", beats: 1 },
    { key: "G4", beats: 2 },
    { key: "E4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "D4", beats: 1 },
    { key: "D4", beats: 1 },
    { key: "C4", beats: 3 },
    { key: "G4", beats: 1 },
    { key: "C4", beats: 1 },
    { key: "C4", beats: 1 },
    { key: "C4", beats: 1 },
    { key: "G4", beats: 1 },
    { key: "A4", beats: 1 },
    { key: "A4", beats: 1 },
    { key: "G4", beats: 2 },
    { key: "E4", beats: 1 },
    { key: "E4", beats: 1 },
    { key: "D4", beats: 1 },
    { key: "D4", beats: 1 },
    { key: "C4", beats: 4 },
  ],
};
